// TODO: change to breadcrumb type then add type to Breadcrumb class
export enum BreadcrumbEnum {
  HOME = '/assets/img/house.png',
  UNITS = '/assets/img/book.png',
  ASSIGNMENTS = '/assets/img/kitty_backpack.png',
  CLASSES = '/assets/img/apple.png',
  DISCUSSION_BOARD = '/assets/img/sort_and_slice_pizzeria.png',
  COMMUNITY = '/assets/img/community.png',
  GRADING = '/assets/img/grades.png',
  GRADE_LEVEL = '/assets/img/book.png',
  GRADE = 'grade',
  UNIT = 'unit',
  DAY = 'day',
  INBOX = '/assets/img/Inbox.png',
  RETRYINBOX = '/assets/img/pencil.png',
  PROFILE = '/assets/img/gear.png',
  PROFESSIONAL_DEV = '/assets/img/eidelweiss.svg',
}
export class Breadcrumb {
  constructor(
    public name: string,
    public path: string,
    public imageUrl?: string,
    public queryParams?: any,
  ) {
    if (typeof imageUrl === 'undefined')
      this.imageUrl = '/assets/img/apple.png';
  }
}

export class BreadcrumbList {
  map: Map<number, Breadcrumb> = new Map();
  readonly UUID_KEY = '${uuid}';
  readonly NUMERIC_KEY = '${#}';
  readonly TITLE_VARIABLE_PATTERN = /&{#:([0-9]+)}/;
  readonly NUMERIC_VARIABLE_PATTERN = /[0-9kK]+/;
  readonly GROUPED_NUMERIC_VARIABLE_PATTERN = /([0-9kK]+)/g;
  readonly UUID_VARIABLE_PATTERN =
    /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;
  readonly GROUPED_UUID_PATTERN =
    /(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/g;

  constructor(map?: Map<number, Breadcrumb>) {
    if (map) this.map = new Map(Array.from(map));
  }

  getTrailStep(path: string): number {
    let result: number = -1;
    this.map.forEach((value: Breadcrumb, key: number) => {
      if (value.path === path) result = key;
    });

    return result;
  }

  toArray(): Breadcrumb[] {
    // Grade K is non-sense to the user but
    // used internally so must be filtered out here
    return Array.from(this.map.values()).filter(
      (item) => item.name !== 'Grade K',
    );
  }

  buildBreadcrumbListFromURL(url: string): BreadcrumbList {
    const lmap: Map<number, Breadcrumb> = new Map();
    const bcl = new BreadcrumbList();
    const splitUrl = url.split('/');

    try {
      this.map.forEach((value: Breadcrumb, key: number) => {
        const bc = { ...value };
        const bcSplitPath = bc.path.split('/');
        let matchCount = 0;
        let titleIntegerMatchCount = 0;

        if (bcSplitPath.length > splitUrl.length) {
          return;
        }

        const titleVariableMatch = this.hasTitleVariable(bc.name);

        bcSplitPath.forEach((path: string, index: number) => {
          const splitUrlPath = splitUrl[index];

          if (path === splitUrlPath) {
            matchCount++;
          } else {
            if (path === this.UUID_KEY) {
              const match = splitUrlPath.match(this.GROUPED_UUID_PATTERN);

              if (match && match.length === 1) {
                matchCount++;
                bcSplitPath[index] = splitUrlPath;
              }
            } else if (path === this.NUMERIC_KEY) {
              const matchUUID = splitUrlPath.match(this.GROUPED_UUID_PATTERN);
              const match = splitUrlPath.match(
                this.GROUPED_NUMERIC_VARIABLE_PATTERN,
              );

              if (match && match.length === 1 && !matchUUID) {
                titleIntegerMatchCount++;
                if (
                  titleVariableMatch &&
                  parseInt(titleVariableMatch[1], 10) === titleIntegerMatchCount
                ) {
                  bc.name = bc.name.replace(
                    titleVariableMatch[0],
                    splitUrlPath,
                  );
                }
                matchCount++;
                bcSplitPath[index] = splitUrlPath;
              }
            }
          }
        });

        if (matchCount === bcSplitPath.length) {
          bc.path = bcSplitPath.join('/');
          lmap.set(key, bc);
        }
      });
    } finally {
      bcl.map = lmap;
    }

    return bcl;
  }

  partial(pos: number, url: string): BreadcrumbList {
    const lmap: Map<number, Breadcrumb> = new Map();
    const bcl = new BreadcrumbList();

    if (pos < 1) pos = 1;
    try {
      this.map.forEach((value: Breadcrumb, key: number) => {
        let bc = { ...value };

        bc = this.replacePathVariables(url, bc, lmap, key);

        if (key <= pos) {
          if (url.includes(bc.path)) lmap.set(key, bc);
        }
      });
    } finally {
      bcl.map = lmap;
    }
    return bcl;
  }

  private replacePathVariables(
    url: string,
    bc: { name: string; path: string; imageUrl?: string },
    lmap: Map<number, Breadcrumb>,
    key: number,
  ): Breadcrumb {
    if (this.matchesUUID(url)) {
      if (bc.path.includes(this.UUID_KEY)) {
        const pattern = this.GROUPED_UUID_PATTERN;
        const variable = this.UUID_KEY;
        bc.path = this.patternReplace(url, bc.path, pattern, variable);

        if (url.includes(bc.path)) {
          lmap.set(key, bc);
        }
      }
    }
    if (this.matchesNumeral(url)) {
      if (bc.path.includes(this.NUMERIC_KEY)) {
        const m = this.hasTitleVariable(bc.name);
        const pattern = this.GROUPED_NUMERIC_VARIABLE_PATTERN;
        const variable = this.NUMERIC_KEY;
        if (m) bc.name = this.replaceTitleVariables(m[0], bc.name, url);

        bc.path = this.patternReplace(url, bc.path, pattern, variable);

        if (url.includes(bc.path)) {
          lmap.set(key, bc);
        }
      }
    }

    return bc;
  }

  matchesUUID(url: string): boolean {
    return !!url.match(this.UUID_VARIABLE_PATTERN);
  }

  matchesNumeral(url: string): boolean {
    const numericPattern = /[0-9kK]+/g;
    return !!url.match(numericPattern);
  }

  patternReplace(
    url: string,
    path: string,
    pattern: RegExp,
    variable: string,
  ): string {
    let cnt = 0;
    while (path.includes(variable)) {
      path = this.replaceFirstOccurance(path, url, pattern, variable, cnt);

      cnt++;
    }
    return path;
  }

  private replaceFirstOccurance(
    path: string,
    url: string,
    pattern: RegExp,
    patternVariable: string,
    cnt: number,
  ): string {
    const m = url.match(pattern);

    if (m) return path.replace(patternVariable, m[cnt]);
    return path;
  }

  private hasTitleVariable(title: string): RegExpMatchArray {
    return title.match(this.TITLE_VARIABLE_PATTERN);
  }

  private replaceTitleVariables(
    titleVar: string,
    title: string,
    path: string,
  ): string {
    let newTitle: string;

    try {
      const m = titleVar.match(this.TITLE_VARIABLE_PATTERN);

      if (m && m.length > 1) {
        const nthOccurance = parseInt(m[1], 10);
        const n = this.getNthOccurance(nthOccurance, path);
        newTitle = title.replace(m[0], n);
      }
    } catch (err) {
      newTitle = title;
    }
    return newTitle;
  }

  getNthOccurance(nthOccurance: number, inThis: string): string {
    let occurrance: string;

    try {
      const m = inThis.match(this.GROUPED_NUMERIC_VARIABLE_PATTERN);
      occurrance = m[nthOccurance - 1];
    } catch (err) {
      occurrance = null;
    }
    return occurrance;
  }
}
